import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { usePackageStoreNew } from '../state/packages.store.new'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'
import { useAuth } from './AuthProvider'
import { sortedPackagesArray } from '../pages/PackagesPage/PackageTimelines/order-packages'

interface IPackagesContext {
  packages: PackageModel[]
}

const PackagesContext = createContext<IPackagesContext>({ packages: [] })

const PackagesProvider = props => {
  const { user } = useAuth()
  const localPackages = usePackageStoreNew(state => state.packages)
  console.log('rendering PackagesProvider', localPackages, user?.packages)

  const [packages, setPackages] = useState<PackageModel[]>(() => {
    if (user?.packages) {
      return sortedPackagesArray(user.packages)
    }

    return sortedPackagesArray(localPackages) ?? []
  })

  // listen for remote packages updates
  useEffect(() => {
    if (user?.packages) {
      console.log('setting remote pkgs')
      setPackages(sortedPackagesArray(user.packages))
    }
  }, [user?.packages])

  // listen for local packages updates, set if user is not signed in
  useEffect(() => {
    if (!user?.id) {
      console.log('setting local pkgs')
      setPackages(sortedPackagesArray(localPackages))
    }
  }, [localPackages, user?.id])

  const contextValues: IPackagesContext = useMemo(() => ({ packages }), [packages])

  return <PackagesContext.Provider value={contextValues}>{props.children}</PackagesContext.Provider>
}

export const usePackages = () => {
  const { packages } = useContext<IPackagesContext>(PackagesContext)
  return packages
}

export const withPackages = Component => {
  return () => {
    return (
      <PackagesProvider>
        <Component />
      </PackagesProvider>
    )
  }
}

export default PackagesProvider
